module.exports = __webpack_public_path__ + "img/schlosserei-raichle-team.c7dd24d4.jpg";